import Typography from "@mui/material/Typography"

function BreakLiner( props: {
  text:string,
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2" | "body1" | "body2" | "caption" | "button" | "overline" | "inherit" | undefined,
  className?:string;
} ) {
  return (
    <Typography variant={props.variant} className={`breakliner ${props.className}`}>
    { props.text.split('\n').map((c,i) =>
        (<span key={i}> {c} </span>)
      ) }
    </Typography>
  )
}

export default BreakLiner